<mat-form-field class="tw-w-full" (click)="openModal($event)">
  <mat-label>{{ 'ITEMS.DETAILS.BARCODE' | translate }}</mat-label>
  
  @if(barcodes.length > 0) {
    <div #chipsWrapper class="tw-flex tw-items-center tw-w-full tw-min-h-[24px] tw-max-h-[24px] tw-overflow-hidden tw-cursor-pointer">
      <mat-chip-set #chipSet class="barcode-chip-set tw-flex! tw-flex-nowrap! tw-gap-1 tw-w-full">
        @for (item of barcodes; track item.barcode; let i = $index) {
          <mat-chip #chipEl class="custom-barcode-chip"
            [class.tw-hidden]="i >= firstHiddenIndex"
            [style.max-width.px]="i === 0 ? firstChipMaxWidth : null"
          >
            <span class="tw-font-bold tw-text-[14px]">{{ item.barcode }}</span>
            @if(item.qty) {
              <span class="tw-flex tw-items-center tw-ml-1 tw-opacity-80 tw-text-[12px]">({{ item.qty }})</span>
            }
          </mat-chip>
        }
  
        <!-- Badge per elementi extra -->
        @if (hiddenCount > 0) {
          <mat-chip class="extra-chip">
            +{{ hiddenCount }}
          </mat-chip>
        }
  
        <mat-chip #extraBadgeMirror 
            style="visibility: hidden; position: absolute; z-index: -1000; pointer-events: none;" 
            aria-hidden="true">
          +{{ barcodes.length }}
        </mat-chip>
      </mat-chip-set>
    </div>
  }
  <input matInput [formControl]="internalControl" class="tw-hidden" readonly>
</mat-form-field>